import React from 'react'
import './App.scss';
import { About,Award,Header,Skills,Work,Footer } from './sections';
import {Navbar} from './components';

const App = () => {
  return (
    <div className="app">
      <Navbar/>
      <Header/>
      <About/>
      <Work/>
      <Skills/>
      <Award/>
      <Footer/>
    </div>
  )
}

export default App